<div class="result-table-container">
  <div class="d-flex justify-content-end">
    @if (isLookup) {
    <button type="button" class="btn btn-link me-auto p-2" (click)="goBack()">
      <span class="fa-angle-left df-icon-wtd me-2"></span>
      {{ goBackLinkText() }}
    </button>
    }
    <button
      i18n="@@upp.global.button.clearTable"
      type="button"
      class="btn btn-link me-2 p-2 mb-2"
      (click)="clearTable()"
      data-test="clear-table-btn"
    >
      Clear table
    </button>
  </div>
  <div class="d-flex justify-content-end">
    <ngb-pagination
      [collectionSize]="resultsNumber"
      [(page)]="currentPage"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      [ngClass]="{ 'with-boundary-links': true }"
    ></ngb-pagination>
  </div>
  <div>
    <table class="table table-hover">
      <thead class="table-light">
        <tr>
          @if (isLookup && !lookupOptions?.singleSelect) {
          <th scope="col">
            <input
              type="checkbox"
              (click)="selectAll()"
              [checked]="allSelected()"
              ngbTooltip="Select all"
              i18n-ngbTooltip="@@upp.global.text.selectAllTooltip"
              [disabled]="!isSearchResultAvailable()"
            /><ng-container i18n="@@upp.pointOfSale.search.table.include">Include</ng-container>
          </th>
          } @if (shouldShowNameColumnFirst()) {
          <th
            i18n="@@upp.pointOfSale.search.table.name"
            scope="col"
            class="sortable cursor-sortable"
            sortable="name"
            isSortable="true"
            (sort)="onSort($event)"
            data-test="name-column"
          >
            Name
          </th>
          } @for (field of displayableFields; track field) {
          <th
            [ngClass]="{ 'sortable cursor-sortable': field.isSortable }"
            attr.i18n="@@upp.pointOfSale.search.table.{{ field.value }}"
            scope="col"
            [sortable]="field?.isSortable ? field.value : ''"
            (sort)="onSort($event)"
            [attr.data-test]="field.value + 'Column'"
          >
            {{ field.label }}
          </th>
          }
          <th scope="col"></th>
        </tr>
      </thead>
      @if (isSearchResultAvailable()) {
      <tbody>
        @for (result of filterSuccessRecords(); track result; let recordIndex = $index) {
        <tr
          [ngClass]="{ selected: isSelected(recordToSearchResult(result).name!) }"
          (click)="isLookup && toggleSelection(recordToSearchResult(result).name!)"
        >
          @if (recordToSearchResult(result); as searchResult) { @if (isLookup && !lookupOptions?.singleSelect) {
          <td>
            <input type="checkbox" [ngModel]="isSelected(searchResult.name)" [ngModelOptions]="{ standalone: true }" />
          </td>
          } @if (shouldShowNameColumnFirst()) {
          <td>{{ searchResult.name }}</td>
          } @for (field of displayableFields; track field) {
          <td>
            @if (field.value === 'name') {
            {{ searchResult.name }}
            } @else if (field.value === 'ruleStatusActive') {
            <span class="form-check-label">{{ $any(searchResult).ruleStatusActive ? 'Active' : 'Inactive' }}</span>
            } @else { @for (value of $any(searchResult)[field.value]?.split(','); track value) {
            <div class="d-flex align-items-center">
              @if (field.displayShortened && value.length > 15) {
              <div [ngbTooltip]="value">
                {{ (value | slice : 0 : 15) + '...' }}
              </div>
              } @else {
              {{ value }}
              } @if (field.hasCopyToClipboard) {
              <app-copy-to-clipboard-button class="d-inline-block" [value]="value"></app-copy-to-clipboard-button>
              }
            </div>
            } }
          </td>
          }
          <td>
            <div class="d-flex justify-content-end gap-1 flex-nowrap">
              @if ((!getConfirmation && !sendingStatus) || !showAlertOnCurrentRow(searchResult)) {
              <div class="d-flex flex-nowrap gap-1">
                @if (shouldShowHistoryButton()) {
                <button
                  i18n-ngbTooltip="@@upp.global.button.search.history"
                  type="button"
                  class="btn btn-link px-3 py-2"
                  ngbTooltip="History"
                  triggers="hover"
                  (click)="showHistory(searchResult.id!, searchResult.name!)"
                  [attr.data-test]="'history-btn-search-' + recordIndex"
                >
                  <span class="fa-light fa-history"></span>
                </button>
                } @if (isShowEnables()) {
                <button
                  i18n-ngbTooltip="@@upp.global.button.search.display"
                  type="button"
                  class="btn btn-link px-3 py-2"
                  ngbTooltip="Display"
                  (click)="showDetails(searchResult.id)"
                  [attr.data-test]="'show-btn-search-' + recordIndex"
                >
                  <span class="fa-light fa-file-lines"></span>
                </button>
                } @if (isModifyEnables()) {
                <button
                  i18n-ngbTooltip="@@upp.global.button.modify"
                  type="button"
                  class="btn btn-link px-3 py-2"
                  ngbTooltip="Modify"
                  [disabled]="!hasManageAccess(result)"
                  (click)="modifyDetails(searchResult.id)"
                  [attr.data-test]="'modify-btn-search-' + recordIndex"
                >
                  <span class="fa-light fa-pen-to-square"></span>
                </button>
                } @if (isCopyEnables()) {
                <button
                  i18n-ngbTooltip="@@upp.global.button.copy"
                  type="button"
                  class="btn btn-link px-3 py-2"
                  ngbTooltip="Copy"
                  [disabled]="!hasManageAccess(result)"
                  (click)="
                    askCopyConfirmation(
                      searchResult.id!,
                      searchResult.name!,
                      searchResult.organization!,
                      searchResult.version!
                    )
                  "
                  [attr.data-test]="'copy-btn-search-' + recordIndex"
                >
                  <span class="fa-light fa-copy"></span>
                </button>
                } @if (isDeleteEnables()) {
                <button
                  i18n-ngbTooltip="@@upp.global.button.search.delete"
                  type="button"
                  class="btn px-3 py-2 border-0"
                  [disabled]="!hasManageAccess(result)"
                  ngbTooltip="Delete"
                  (click)="
                    askDeleteConfirmation(
                      searchResult.id!,
                      searchResult.name!,
                      searchResult.organization!,
                      searchResult.version!
                    )
                  "
                  [attr.data-test]="'delete-btn-search-' + recordIndex"
                >
                  <span class="fa-light fa-trash-can text-danger"></span>
                </button>
                }
              </div>
              } @if (getConfirmation && showAlertOnCurrentRow(searchResult)) {
              <ngb-alert insert-alert-icon [dismissible]="false" type="warning" class="p-3">
                <div class="ms-2">
                  <span class="fa-question-circle me-2"></span>
                  <span data-test="confirmation-message">{{ getConfirmationMessage() }}</span>
                  <span class="ms-2"
                    ><strong>{{ getNameForConfirmationMessage() }}</strong></span
                  >
                </div>
                <div class="me-4 ms-4">
                  <button
                    i18n="@@upp.global.button.abort"
                    type="button"
                    class="btn btn-primary mb-2 mb-md-0 me-2"
                    (click)="abortConfirmation()"
                    data-test="abort-confirmation-btn"
                  >
                    Abort
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mb-2 mb-md-0"
                    (click)="executeActionAfterConfirmation(searchResult)"
                    data-test="delete-confirmation-btn"
                  >
                    {{ getConfirmationActionMessage() }}
                  </button>
                </div>
              </ngb-alert>
              }
              <ama-loading-alert
                [sendingStatus]="!!sendingStatus && this.entryToUpdateName() === searchResult.name"
                message="Loading..."
                i18n-message="@@upp.global.messages.loading"
              >
              </ama-loading-alert>
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
      }
    </table>
    @if (!isSearchResultAvailable()) {
    <div id="noResult"><strong> No result </strong></div>
    } @if (isSearchResultAvailable()) {
    <div class="d-flex justify-content-start">
      @if (isLookup) {
      <button type="button" class="btn btn-link me-auto p-2" (click)="goBack()">
        <span class="fa-angle-left df-icon-wtd me-2"></span>
        {{ goBackLinkText() }}
      </button>
      }
    </div>
    }
    <div class="d-flex justify-content-end form-check-inline">
      <div class="input-group-sm mb-5">
        <label for="pageSize" class="form-label">Items per page: </label>
        <input
          [(ngModel)]="pageSize"
          maxlength="2"
          size="2"
          class="form-control items-per-page-input d-inline"
          id="pageSize"
          (input)="handleInvalidInput($event)"
        />
      </div>
      <ngb-pagination
        [collectionSize]="resultsNumber"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [maxSize]="3"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        [ngClass]="{ 'with-boundary-links': true }"
      ></ngb-pagination>
    </div>
  </div>
</div>
